
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const  Hero = () => {
   const lang = useSelector((state) => state.cart.lang);
      const theme = useSelector((state) => state.cart.theme);
  const Heros = useSelector((state) => state.cart.hero);



  const guarentee=[
    lang=== 'en' ? 'Years ' : 'سنين ',
    lang=== 'en' ? 'Months ' : 'شهور ',
    lang=== 'en' ? 'Days ' : 'ايام ',
  ]

  
  const guarentee_=[
    lang=== 'en' ? 'Year ' : 'سنة ',
    lang=== 'en' ? 'Month ' : 'شهر ',
    lang=== 'en' ? 'Day ' : 'يوم ',
  ]

  const [next,setNext] = useState(true)
  
   const [index,setIndex] = useState(0)
   const [show,setShow] = useState(false)

   useEffect(() => {
  
    setTimeout(() => {
      setShow(true);
  }, 500);
    
  }, []);





  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  
  function handleTouchStart(e) {
      setTouchStart(e.targetTouches[0].clientX);
  }
  
  function handleTouchMove(e) {
      setTouchEnd(e.targetTouches[0].clientX);
  }
  
  function handleTouchEnd() {
      if (touchStart - touchEnd > 175) {
          // do your stuff here for left swipe
          setNext(false)
          setShow(false)
       
          
         setTimeout(() => {
             setNext(true);
             if(index < Heros.length-1){
           setIndex(index+1)
         }else{
           setIndex(0)
         }
            }, 500);
         setTimeout(() => {
             setShow(true);
            }, 1000);
      }
  
      if (touchStart - touchEnd < -175) {
          // do your stuff here for right swipe
          setNext(true)
          setShow(false)
          
          setTimeout(() => {
              setNext(false);
              if(index > 0){
            setIndex(index-1)
          }else{
            setIndex(Heros.length-1)
          }
             }, 500);
           setTimeout(() => {
              setShow(true);
             }, 1000)
      }
  }





  return (
    <section className={`relative ${theme === 'LM' ? 'bg-zinc-200' : 'bg-zinc-1000'} bg-heroBG px-10 pt-[80px] max-h-screen  w-full `} 
     onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} 
    >
       <div className="relative flex w-full">
   <div style={{overflowX:'hidden', maxWidth:'100%',zIndex:3}} dir="ltr" className=" m-auto  inline-flex gap-4 items-center self-center p-1  ">
         
          <button 
          
          onClick={()=>{
            if(Heros.length > 0){
                setNext(true)
                setShow(false)
              
              setTimeout(() => {
                  setNext(false);
                  if(index > 0){
                setIndex(index-1)
              }else{
                setIndex(Heros.length-1)
              }
                 }, 500);
               setTimeout(() => {
                  setShow(true);
                 }, 1000)
                }
            }} aria-label="Previous slide">
              <img
                src="Icons/LeftButton.svg"
                alt=""
                className="object-contain shrink-0 self-stretch my-auto  h-[14px] w-[14px] md:w-[19px] md:h-[19px]"
              />
            </button>

          <div style={{overflowX:'auto', maxWidth:'80%'}} dir="ltr" className= {`${theme === 'LM' ? 'light-scrollbar' : 'dark-scrollbar' } flex gap-2 items-center self-center py-5 `} >
         
            {Heros.map((item, i) => (
              <button key={`Slider ${i}`} onClick={()=>{
                    if(Heros.length > 0){
                if(i > index){
                  //prev
                  setNext(false)
                setShow(false)
              
              setTimeout(() => {
                  setNext(true);
                
                setIndex(i)
            
                 }, 500);
               setTimeout(() => {
                  setShow(true);
                 }, 1000)
                }
                else if(i < index){
                  //next
                  setNext(true)
                  setShow(false)
               
              setTimeout(() => {
                  setNext(false);
              
                  setIndex(i)
                 }, 500);

              setTimeout(() => {
                  setShow(true);
                 }, 1000)
                }
                    }
              }} className={`transition-all delay-150 duration-500 flex shrink-0 self-stretch my-auto h-[12px] w-[12px] md:w-[17px] md:h-[17px] rounded-full ${Number(i) === Number(index) ? theme === 'LM' ? 'bg-primary' : 'bg-primary_'  : 'bg-zinc-300'}  `} />
          ))}
          
          </div>
          <button onClick={()=>{
                if(Heros.length > 0){
               setNext(false)
               setShow(false)
               
              setTimeout(() => {
                  setNext(true);
                  if(index < Heros.length-1){
                setIndex(index+1)
              }else{
                setIndex(0)
              }
                 }, 500);
              setTimeout(() => {
                  setShow(true);
                 }, 1000);
                }
            }} aria-label="Next slide">
              <img
                src="Icons/RightButton.svg"
                alt=""
                className="object-contain shrink-0 self-stretch my-auto  h-[14px] w-[14px] md:w-[19px] md:h-[19px]"
              />
            </button>

</div>
          </div>
       
        <div   className={`relative flex flex-col w-full  select-none`} >
          <div style={{zIndex:4 }} className={`pb-3 
          ${show ? ' transition-all  duration-500   opacity-[1] translate-x-[0px] rotate-0' : `transition-all delay-200  duration-500  opacity-[0] ${next? 'translate-x-[120%]' : '-translate-x-[120%]'} `}`}>

            <div  className="flex gap-5 items-center  ">


            
              <div className={'relative ml-5 w-[100%]  '}>
                <div className="flex flex-col  w-full  ">
                    <div className="flex flex-col self-stretch my-auto  ">
                      <h4 dir={lang=== 'en' ?  "ltr" : "rtl" }  style={{fontFamily:'CairoExtraBold',whiteSpace:'pre-wrap'}} className= {`${lang === 'en' ? 'text-left' :'text-right'}  w-full   text-[20px]  xl:text-[50px] xl:leading-[70px]  lg:text-[40px] lg:leading-[60px] md:text-[30px] md:leading-[50px]  sm:text-[20px] sm:leading-[40px] xs:text-[20px] xs:leading-[35px]`} >
                      {Heros.length > 0 ? 
                      
                      lang=== 'en' ? Heros[index].text_en  : Heros[index].text 
                      
                      :''}
                      </h4>
                      <Link to={`brand/${Heros.length > 0 ? Heros[index].agent_fid :''}`} className=" flex flex-col self-center  max-w-full h-[120px]  w-[150px]  mt-4 md:h-[180px] md:w-[300px]  ">
                      <img
                        src={`https://dev.dawasmart.com/img/${Heros.length > 0 ? Heros[index].brand :''}`}
                        alt={Heros.length > 0 ?  Heros[index].brand_alt :''}
                        className="object-contain m-auto max-w-full   w-[90%] max-w-[150px]  max-h-[120px] md:max-h-[180px] md:max-w-[300px]"
                      />
                       </Link>
                    </div>
                 
                  <Link  to={`product/${Heros.length > 0 ? Heros[index].product :''}`} style={{fontFamily:'CairoBold'}} className= {`  ${theme === 'LM' ? 'bg-primary bg-gradient-to-l from-sky-300' : 'bg-primary_ bg-gradient-to-l from-orange-300 '}  mt-4  self-end max-w-[250px]  w-[80%]   leading-none text-white rounded py-4 hover:opacity-[0.8]`}>
                   {lang === 'en' ? 'Details' :' إعرف أكثر'}
                  </Link>
                  
                </div>
              </div>





  <div style={{overflowX:'hidden', maxWidth:'100%',zIndex:3}} className="relative flex w-full h-[20px] py-5  " />
         
       
              
            </div>



            
       
          </div>
       <div dir={lang === 'en'? 'rtl' : "ltr"} className={`absolute w-full     bottom-[-55px] xs:bottom-[-40px] sm:bottom-[-55px]  md:bottom-[-75px] lg:bottom-[-125px]  xl:bottom-[-150px]
         ${show ? `transition-all   duration-500  translate-x-[0px] ` : `transition-all   duration-500 delay-200   ${ next? "translate-x-[100%]" : "translate-x-[-100%]" } `}  ` } >
                <img
                  src={`https://dev.dawasmart.com/img/${Heros.length > 0 ? Heros[index].img :''}`}

                  alt={Heros.length > 0 ?  Heros[index].alt :''}
                  className={` object-contain  max-w-[40%]  w-full  max-h-[150px] xs:max-h-[100px] sm:max-h-[150px]  md:max-h-[200px] lg:max-h-[300px]  xl:max-h-[350px]  
                  ${show ? `transition-all   duration-500  opacity-[1] rotate-0` : `transition-all  rotate-45 duration-500  opacity-[0]  `}  `}
                />
    
   
              </div>
     
          
        </div>
        

    </section>
  );
}
  